$(document).ready(function() {
  // 所在地の初期値をセット
  changeSelectPrefectures();
});


//所在地を選択
$(document).on('change', '.select-prefectures', function() {
  changeSelectPrefectures();
});

function changeSelectPrefectures(){
  const selectedPrefectures = [];
  $('input[name="search_school_form[prefecture_ids][]"]:checked').each(function() {
    selectedPrefectures.push($(this).siblings('.c-checkbox__text').text());
  });

  const outputText = selectedPrefectures.length > 0 ? selectedPrefectures.join(', ') : '未選択';
  $('#selected-prefectures').text(outputText);
}

// "すべてを選択" のチェックボックスが変更されたときの処理
$(document).on('change', '#checkAllPrefecture', function() {
  if ($(this).is(':checked')) {
    $('.prefecture-checkbox').prop('checked', true); // すべての都道府県のチェックボックスをチェック
  } else {
    $('.prefecture-checkbox').prop('checked', false); // すべての都道府県のチェックを外す
  }
  changeSelectPrefectures();
});

$(document).on('change', '.prefecture-checkbox', function() {
  // 全ての都道府県のチェックが外れた場合に "すべてを選択 のチェックを外す
  if ($('.prefecture-checkbox:checked').length === $('.prefecture-checkbox').length) {
    $('#checkAllPrefecture').prop('checked', true);
  } else {
    $('#checkAllPrefecture').prop('checked', false);
  }
});
